import { useMemo } from 'react';
import ACContentBreakdownList from 'academy-common-lib/components/list/ACContentBreakdownList';
import { ExerciseAssetTypename, LinkAssetTypename, QuizAssetTypename, VideoAssetTypename } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/LessonChirpService';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentOverviewChirp = ({
  content,
  hasCertificate,
  hasStudyGuide
}) => {
  const {
    videos,
    quizzes,
    practicalExercises,
    links
  } = useMemo(() => {
    return (content || []).reduce((acc, c) => {
      if (c.__typename === VideoAssetTypename) {
        ++acc.videos;
      } else if (c.__typename === LinkAssetTypename) {
        ++acc.links;
      } else if (c.__typename === QuizAssetTypename) {
        ++acc.quizzes;
      } else if (c.__typename === ExerciseAssetTypename) {
        ++acc.practicalExercises;
      }
      return acc;
    }, {
      videos: 0,
      quizzes: 0,
      practicalExercises: 0,
      links: 0
    });
  }, [content]);
  return /*#__PURE__*/_jsx(ACContentBreakdownList, {
    certificateCount: hasCertificate ? 1 : 0,
    exerciseCount: practicalExercises,
    quizCount: quizzes,
    resourceCount: links + (hasStudyGuide ? 1 : 0),
    videoCount: videos
  });
};
const ContentOverview = ({
  content,
  hasCertificate,
  hasStudyGuide
}) => {
  return /*#__PURE__*/_jsx(ContentOverviewChirp, {
    content: content,
    hasCertificate: hasCertificate,
    hasStudyGuide: hasStudyGuide
  });
};
export default ContentOverview;